import { createSlice } from '@reduxjs/toolkit';
import absWebService from 'app/services/absWebService';
import i18next from 'i18next';
import { showMessage } from 'app/store/abs/messageSlice';
import { setUser } from 'app/store/userSlice';

//special!!
export const updateCompanySettings = (data, newuser) => async dispatch => {

	dispatch(setLoading(true));
	const response = await absWebService
		.communicationHandler("abs_update_company_settings", data)
		.catch(error => {
			if (error == null) {
				error = i18next.t("abswebservice:UNKNOWNERROR");
			}
			//give back error for processing below
			return error;
		});

	//await catch error or server response
	const respdata = await response;
	if (absWebService.isResponseArrSuccess(respdata)) {
		//alert(JSON.stringify(respdata));
		//dispatch(showMessage({ message: "success fetching data", variant: 'success' }));

		var returndataarr = absWebService.getDataFromResponseArr(respdata);

		dispatch(setUser(newuser));

		dispatch(successChangeDone(returndataarr));

		return absWebService.getDataFromResponseArr(respdata);
	}
	else {
		dispatch(setLoading(false));
		var errormessage = absWebService.getDisplayTextFromResponseArr(respdata);
		dispatch(showMessage({ message: errormessage, variant: 'error' }));
		return "error";
	}
};

export const communicateWithAPI = (apicall, data, showloading = true) => async dispatch => {

	if (showloading) {
		dispatch(setLoading(true));
	}

	const response = await absWebService
		.communicationHandler(apicall, data)
		.catch(error => {
			if (error == null) {
				error = i18next.t("abswebservice:UNKNOWNERROR");
			}
			//give back error for processing below
			return error;
		});

	//await catch error or server response
	const respdata = await response;

	if (absWebService.isResponseArrSuccess(respdata)) {
		//alert(JSON.stringify(respdata));

		switch (apicall) {
			case "abs_get_company_settings":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				dispatch(successGetCompanySettings(returndataarr));
				break;
			case "abs_get_all_for_usermanagement":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				dispatch(successGetAllForUsermanagement(returndataarr));
				break;
			case "abs_change_user_active_state":
			case "abs_change_user":
			case "abs_create_user":
				//get new user list
				dispatch(communicateWithAPI("abs_get_all_for_usermanagement", null));
				break;
			case "abs_multiple_request_password_reset":
				dispatch(communicateWithAPI("abs_get_all_for_usermanagement", null));
				dispatch(showMessage({ message: i18next.t("absadministration:PASSWORTREQUESTDONE"), variant: 'success' }));
				break;
			case "tl_get_server_settings":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				dispatch(successGetTLServerSettings(returndataarr));
				break;
			case "tl_set_server_settings":
				//get new server settings
				dispatch(communicateWithAPI("tl_get_server_settings", null));
				break;
			case "tl_get_holidays":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				dispatch(successGetTLHolidays(returndataarr));
				break;
			case "tl_set_holidays":
				//get new holidays
				dispatch(communicateWithAPI("tl_get_holidays", null));
				break;
			case "tl_get_religions":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				dispatch(successGetTLReligions(returndataarr));
				break;
			case "tl_set_religions":
				//get new religions
				dispatch(communicateWithAPI("tl_get_religions", null));
				break;
			case "tl_get_business_locations":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				dispatch(successGetTLBusinessLocations(returndataarr));
				break;
			case "tl_set_business_locations":
				//get new business locations
				dispatch(communicateWithAPI("tl_get_business_locations", null));
				break;
			case "tl_get_user_settings_admin":
			case "eo_get_user_settings_admin":
				// Return the data directly for the caller
				if (showloading) {
					dispatch(setLoading(false));
				}
				return absWebService.getDataFromResponseArr(respdata);
			case "tl_set_user_settings_admin":
				// No need to reload, just return success
				break;
			case "tl_get_activity_templates":
			case "tl_save_activity_template":
			case "tl_delete_activity_template":
			case "tl_get_all_plain_objectitems":
			case "abs_get_notification_preferences":
			case "abs_save_notification_preferences":
			case "abs_delete_push_device":
			case "abs_set_push_device_enabled":
			case "abs_send_test_push":
				if (showloading) {
					dispatch(setLoading(false));
				}
				return absWebService.getDataFromResponseArr(respdata);
			case "eo_get_server_settings":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				dispatch(successGetEOServerSettings(returndataarr));
				break;
			case "eo_set_server_settings":
				//get new server settings
				dispatch(communicateWithAPI("eo_get_server_settings", null));
				break;
			case "tl_get_hierarchy_tree":
			case "tl_set_hierarchy_tree":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				dispatch(successGetTLHierarchy(returndataarr));
				break;
			case "tl_get_workmodes":
			case "tl_set_workmodes":
			case "tl_create_hierarchy_role":
			case "tl_edit_hierarchy_role":
			case "tl_delete_hierarchy_role":
				// The caller handles the returned administration data.
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				if (showloading) {
					dispatch(setLoading(false));
				}
				return returndataarr;
			case "tl_get_all_objects":
			case "tl_set_all_objects":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				dispatch(successGetTLObjects(returndataarr));
				break;
			case "abs_supportrequest":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				dispatch(showMessage({ message: returndataarr, variant: 'success' }));
				break;
			case "abs_execute_webcron":
				dispatch(showMessage({ message: i18next.t("absadministration:WEBCRONRUNNING"), variant: 'success' }));
				break;
			case "tl_clear_all_carryovers":
			case "tl_recalc_all_annual_periods":
				// No success message - info dialog is shown in the handler
				break;
			case "abs_get_all_nfc_chips":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				dispatch(successGetAllNFCChips(returndataarr));
				break;
			case "abs_create_nfc_chip":
			case "abs_update_nfc_chip":
			case "abs_create_nfc_chip_assignment":
			case "abs_update_nfc_chip_assignment":
			case "abs_delete_nfc_chip":
				// Reload chips after any modification
				dispatch(communicateWithAPI("abs_get_all_nfc_chips", null));
				break;
			case "abs_start_impersonation":
			case "abs_stop_impersonation":
				// Caller handles redirect; no toast needed
				if (showloading) {
					dispatch(setLoading(false));
				}
				return absWebService.getDataFromResponseArr(respdata);
			default:
				dispatch(showMessage({ message: "success fetching data", variant: 'success' }));
				break;
		}

		if (showloading) {
			dispatch(setLoading(false));
		}

		return absWebService.getDataFromResponseArr(respdata);
	}
	else {
		if (showloading) {
			dispatch(setLoading(false));
		}
		var errormessage = absWebService.getDisplayTextFromResponseArr(respdata);
		dispatch(showMessage({ message: errormessage, variant: 'error' }));
		return "error";
	}
};

const initialState = {
	loading: false,
	searchText: '',
	usermanagement: {
		users: [],
		countriesWithProvinces: [],
		allModules: [],
		allAdminRoles: [],
		userDialog: {
			type: 'new',
			props: {
				open: false
			},
			data: null
		}
	},
	tl: {
		hierarchytreeflat: [],
		objects: [],
		serversettings: {
		},
		holidays: {
			holidays: [],
			referenceData: {
				countries: [],
				provinces: [],
				religions: []
			}
		},
		religions: {
			religions: []
		},
		businessLocations: {
			locations: [],
			referenceData: {
				countries: [],
				provinces: []
			}
		}
	},
	eo: {
		serversettings: {
		}
	},
	hardware: {
		nfcChips: []
	},
	company: {
		moduleLicences: [],
		serversettings: null,
		databaseSize: null
	}
};

const absAdministrationSlice = createSlice({
	name: 'absAdministration/administration',
	initialState,
	reducers: {
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
		successChangeDone: (state, action) => {
			state.loading = false;
		},
		successGetAllForUsermanagement: (state, action) => {
			state.usermanagement.users = action.payload.allusers != null ? action.payload.allusers : [];
			state.usermanagement.countriesWithProvinces = action.payload.countrieswithprovinces;
			state.usermanagement.allModules = action.payload.allmodules;
			state.usermanagement.allAdminRoles = action.payload.alladminroles;
		},
		successGetTLServerSettings: (state, action) => {
			state.tl.serversettings = action.payload;
		},
		successGetTLHolidays: (state, action) => {
			state.tl.holidays.holidays = action.payload.holidays != null ? action.payload.holidays : [];
			state.tl.holidays.referenceData = action.payload.referenceData != null ? action.payload.referenceData : { countries: [], provinces: [], religions: [] };
		},
		successGetTLReligions: (state, action) => {
			state.tl.religions.religions = action.payload != null ? action.payload : [];
		},
		successGetTLBusinessLocations: (state, action) => {
			state.tl.businessLocations.locations = action.payload.locations != null ? action.payload.locations : [];
			state.tl.businessLocations.referenceData = action.payload.referenceData != null ? action.payload.referenceData : { countries: [], provinces: [] };
		},
		successGetEOServerSettings: (state, action) => {
			state.eo.serversettings = action.payload;
		},
		successGetTLHierarchy: (state, action) => {
			state.tl.hierarchytreeflat = action.payload.hierarchytreeflat != null ? action.payload.hierarchytreeflat : [];
			state.tl.availableusers = action.payload.availableusers;
			state.tl.availableroles = action.payload.availableroles;
		},
		successGetTLObjects: (state, action) => {
			state.tl.objects = action.payload != null ? action.payload : [];
		},
		successGetAllNFCChips: (state, action) => {
			state.hardware.nfcChips = action.payload != null ? action.payload : [];
		},
		successGetCompanySettings: (state, action) => {
			state.company.moduleLicences = action.payload.modulelicences != null ? action.payload.modulelicences : [];
			state.company.serversettings = action.payload.serversettings != null ? action.payload.serversettings : null;
			state.company.databaseSize = action.payload.databaseSize != null ? action.payload.databaseSize : null;
		},
		setHeaderSearchText: {
			reducer: (state, action) => {
				state.searchText = action.payload;
			},
			prepare: event => ({ payload: event.target.value || '' })
		},
		openNewUserDialog: (state, action) => {
			state.usermanagement.userDialog = {
				type: 'new',
				props: {
					open: true
				},
				data: null
			};
		},
		closeNewUserDialog: (state, action) => {
			state.usermanagement.userDialog = {
				type: 'new',
				props: {
					open: false
				},
				data: null
			};
		},
		openEditUserDialog: (state, action) => {
			state.usermanagement.userDialog = {
				type: 'edit',
				props: {
					open: true
				},
				data: action.payload
			};
		},
		closeEditUserDialog: (state, action) => {
			state.usermanagement.userDialog = {
				type: 'edit',
				props: {
					open: false
				},
				data: null
			};
		}
	},
	extraReducers: {}
});

export const { setLoading, successChangeDone, successGetAllForUsermanagement, successGetTLServerSettings, successGetTLHolidays, successGetTLReligions, successGetTLBusinessLocations, successGetEOServerSettings, successGetTLHierarchy, successGetTLObjects, successGetAllNFCChips, successGetCompanySettings, setHeaderSearchText, openNewUserDialog, closeNewUserDialog, openEditUserDialog, closeEditUserDialog } = absAdministrationSlice.actions;

export default absAdministrationSlice.reducer;
